export default __webpack_public_path__ + "static/media/bids7.02981185.png";